export function getTranslationsLoadPath() {
  return `${globalThis.env.EDITOR_REMOTE}/files/locales/{{lng}}/translations.json`;
}
